import styled from "styled-components"
import fontValues from "../../../assets/values/fontValues/fontValues.json"

export const TestimonialsTitle = styled.p `

    width: fit-content;
    height: fit-content;
    margin: 20px 0 0 0;
    color: ${({theme}) => theme.colors.DARK_TEXT};
    font-family: ${fontValues.TEXT_FONT_FAMILY};
    font-size: ${fontValues.HOME_TITLE2_SIZE};
    font-weight: bolder;

`